import React, { Fragment, useState, useEffect } from 'react'
import {
  Box,
  Button,
  Grid,
  IconButton,
  LinearProgress,
  Tooltip,
  Typography,
  
  Link,
  CircularProgress,
  TextField,
  MenuItem,
  ListItemText,
  FormControlLabel,
  Checkbox
} from '@mui/material'
import { withStyles } from '@mui/styles'
import { apiCall, ApiConfig } from '../../../config/api'
import { SnackBar } from '../../SnackBar/Snackbar'
import { ApiResponse } from '../../../models/ApiResponse'
import axios from 'axios'

import HelpIcon from '@mui/icons-material/Help'
import { templateMassiveProcessInternalOrder } from '../../../const/templatesFileName'
import {
  CityProvince,
  NeighborhoodComuna,
  StatesRegion
} from '../../../interfaces/Location/Location'
import { stateRegion } from '../../../utils/states-region'
import { provinces } from '../../../utils/city-provincia'
import { cities } from '../../../utils/neighborhood-comuna'
import { useCourier } from '../../../hooks/useCourier'
import { Courier, CourierService } from '../../../interfaces/Courier'
import {
  configDateInitial,
  localDateFromInput
} from '../../../utils/dateHelper'
import { useUser } from '../../../hooks/useUser'
import { useAuth } from 'oidc-react'
import { OrderOriginsDDL } from '../../OrderOrigin/OrderOriginsDDL'

/*
Copyright 2022-07-12 por Alfonso Moya Ecomsur Holding S.A ©
Detalle: Agrega selección warehouse al crear WorkOrder por archivo.
*/

const BorderLinearProgress = withStyles(() => ({
  root: {
    height: 15,
    borderRadius: 5
  },
  colorPrimary: {
    backgroundColor: '#EEEEEE'
  },
  bar: {
    borderRadius: 5,
    backgroundColor: '#1a90ff'
  }
}))(LinearProgress)

class SnackBarStatus {
  isOpen: boolean = false
  message: string = ''
  status: string = ''
}

interface UploadInternalOrderFileProps {}

export const UploadInternalOrderFile: React.FC<
  UploadInternalOrderFileProps
> = () => {
  interface IUploadFile {
    courierDeliveryDate: string
    courierId: number
    courierServiceId: number
    neighborhoodId: number
    stateId: number
    cityId: number
    userId: number
    rtv: boolean
    comments: string
    orderOriginId: number
  }

  const auth = useAuth()
  const isAndina = auth.userData?.profile.tenant === 'AndinaCL'

  const busquedaInitialState: IUploadFile = {
    courierDeliveryDate: configDateInitial(0),
    courierId: -1,
    courierServiceId: -1,
    neighborhoodId: !isAndina ? 1 : -1,
    stateId: !isAndina ? 1 : -1,
    cityId: !isAndina ? 1 : -1,
    userId: 0,
    rtv: false,
    comments: '',
    orderOriginId: 0
  }

  const {
    userDataState: { userData }
  } = useUser()

  const maxFileSize = 2097152
  const [states, setState] = useState<StatesRegion[]>([])
  const [city, setCity] = useState<CityProvince[]>([])
  const [neighborhood, setNeighborhood] = useState<NeighborhoodComuna[]>([])
  const [isUploading, setIsUploading] = useState<boolean>(false)
  const [selectedFiles, setSelectedFiles] = useState<any[] | undefined>(
    undefined
  )
  const [currentFile, setCurrentFile] = useState<any | undefined>(undefined)
  const [progress, setProgress] = useState<number>(0)
  const [snackBarStatus, setSnackBarStatus] = useState<SnackBarStatus>(
    new SnackBarStatus()
  )
  const [disabledLink, setDisabledLink] = useState<boolean>(false)
  const [busqueda, setBusqueda] = useState<IUploadFile>(busquedaInitialState)
  const [isRTV, setIsRTV] = useState<boolean>(busquedaInitialState.rtv)

  const notify = (message: string, status: string) => {
    const newStatus: SnackBarStatus = {
      isOpen: true,
      message: message,
      status: status
    }
    setSnackBarStatus(newStatus)
  }

  const handleSnackbar = (isOpen: boolean) => {
    setSnackBarStatus({ ...snackBarStatus, isOpen: isOpen })
  }

  const handleSelectFile = (event: any) => {
    setSelectedFiles(event.target.files)
    setProgress(0)
    setSnackBarStatus(new SnackBarStatus())
  }

  const sizeLabel = (size: number): string => {
    let label = ''
    if (size / 1024 / 1024 > 1) label = (size / 1024 / 1024).toFixed(2) + ' MB'
    else if (size / 1024 > 1) label = (size / 1024).toFixed(0) + ' KB'
    else label = size.toFixed(2) + ' Bytes'
    return label
  }

  const validateFile = (files: any[] | undefined): string => {
    if (!files || files.length === 0) {
      return 'Ningún archivo seleccionado'
    }

    const selectedFile = files[0]

    if (selectedFile.size > maxFileSize) {
      const maxLabel = sizeLabel(maxFileSize)
      return `El archivo seleccionado supera el tamaño máximo: ${maxLabel}`
    }

    if (selectedFile.name.toLowerCase().indexOf('.xls') < 0) {
      return `El archivo seleccionado no es de tipo Excel (.xls)`
    }

    return ''
  }

  const callUpload = (file: any, onUploadProgress: (event: any) => void) => {
    const formData = new FormData()
    formData.append('file', file)
    formData.append(
      'courierDeliveryDate',
      `${localDateFromInput(busqueda.courierDeliveryDate)}`
    )
    formData.append('courierId', `${busqueda.courierId}`)
    formData.append('courierServiceId', `${busqueda.courierServiceId}`)
    formData.append('stateId', `${busqueda.stateId}`)
    formData.append('cityId', `${busqueda.cityId}`)
    formData.append('neighborhoodId', `${busqueda.neighborhoodId}`)
    formData.append('userId', `${userData?.userId}`)
    formData.append('rtv', `${busqueda?.rtv}`)
    formData.append('comments', `${busqueda.comments}`)
    formData.append('orderOriginId', `${busqueda.orderOriginId}`)

    const axiosInstance = axios.create({
      baseURL: ApiConfig.ProcessApi,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    return axiosInstance.post(`/InternalOrderUploadFile`, formData, {
      onUploadProgress
    })
  }

  const handleUpload = () => {
    const validateError = validateFile(selectedFiles)
    if (validateError !== '') {
      setCurrentFile(undefined)
      notify(validateError, 'error')
      return
    }

    if (!selectedFiles) return

    const selectedFile = selectedFiles[0]
    setProgress(0)
    setCurrentFile(selectedFile)
    setIsUploading(true)

    callUpload(selectedFile, (event) => {
      setProgress(Math.round((100 * event.loaded) / event.total))
    })
      .then((response) => {
        const apiResponse = response.data as ApiResponse
        setIsUploading(false)
        if (apiResponse.success) {
          notify('El archivo ha sido cargado para su procesamiento', 'success')
        } else {
          notify(
            `Error en carga de archivo: ${
              apiResponse.message || 'falla en el servicio.'
            }`,
            'error'
          )
        }
        setCurrentFile(undefined)
        setSelectedFiles(undefined)
        setProgress(0)
      })
      .catch((error) => {
        setIsUploading(false)
        setProgress(0)
        notify(
          `Error en carga de archivo: ${
            error.response?.data?.message || 'falla en el servicio.'
          }`,
          'error'
        )
        setCurrentFile(undefined)
        setSelectedFiles(undefined)
        setProgress(0)
      })
  }

  const handleDownloadTemplate = () => {
    setDisabledLink(true)
    setTimeout(() => {
      apiCall(
        'GET',
        `${ApiConfig.ProcessApi}/GetTemplateFile/${templateMassiveProcessInternalOrder}`,
        {
          responseType: 'blob'
        }
      )
        .then((response: any) => {
          if (response.status === 200 && response.data !== null) {
            const raw = window.atob(response.data.file)
            const uInt8Array = new Uint8Array(raw.length)
            for (let i = 0; i < raw.length; ++i) {
              uInt8Array[i] = raw.charCodeAt(i)
            }
            const link = document.createElement('a')
            const blob = new Blob([uInt8Array], {
              type: response.data.mimeType
            })
            link.style.display = 'none'
            link.href = URL.createObjectURL(blob)
            link.setAttribute('download', response.data.name)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }
        })
        .catch((message: any) => {
          console.log('message: ', message)
        })
      setDisabledLink(false)
    }, 1500)
  }

  const handleBusqueda = (event: React.ChangeEvent<HTMLInputElement>) => {
    setBusqueda({ ...busqueda, [event.target.name]: event.target.value })
  }

  const {
    couriersState: { couriers },
    getCouriers
  } = useCourier()

  useEffect(() => {
    if (couriers?.length === 0) {
      getCouriers()
    }
  }, [])

  useEffect(() => {
    setCity(provinces)
    setNeighborhood(cities)
    setState(stateRegion as [])
  }, [])

  useEffect(() => {
    setBusqueda({
      ...busqueda,
      ['cityId']: -1,
      ['neighborhoodId']: -1
    })
  }, [busqueda.stateId])

  useEffect(() => {
    setBusqueda({
      ...busqueda,
      ['courierServiceId']: -1
    })
  }, [busqueda.courierId])

  useEffect(() => {
    setBusqueda((prevState) => ({
      ...prevState,
      ['rtv']: isRTV
    }))
  }, [isRTV])

  const courierServices = () => {
    let courierServices: { name: string; value: string }[] = []

    if (
      couriers !== undefined &&
      couriers.length > 0 &&
      busqueda.courierId !== -1 &&
      couriers.filter((f) => f.courierId === busqueda.courierId).length > 0
    ) {
      courierServices = couriers
        ?.filter((f) => f.courierId === busqueda.courierId)[0]
        .courierServices.map((opt: CourierService) => {
          return {
            value: `${opt.courierServiceId}`,
            name: `${opt.name}`
          }
        })
    }

    return courierServices
  }

  return (
    <Fragment>
      <Grid container spacing={4} direction='column' alignItems='center'>
        <Typography variant='h4' component='h4' style={{ padding: '10px' }}>
          Crear pedido interno
        </Typography>

        {isAndina && (
          <Grid container item xs={12} spacing={3}>
            <Grid item xs={12} sm={4}>
              <TextField
                select
                fullWidth
                label='Región'
                id='stateId'
                name='stateId'
                onChange={(e: any) => {
                  handleBusqueda(e)
                }}
                variant='outlined'
                value={busqueda.stateId}
                error={busqueda.stateId === -1}
                helperText={
                  busqueda.stateId === -1 ? 'Debe seleccionar una región' : ''
                }
              >
                <MenuItem key={-1} value={-1}>{`Seleccione Región`}</MenuItem>
                {states &&
                  states.map((opt: StatesRegion) => (
                    <MenuItem key={opt.stateCode} value={opt.stateCode}>
                      {opt.name}
                    </MenuItem>
                  ))}
              </TextField>
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                select
                fullWidth
                label='Provincia'
                id='cityId'
                name='cityId'
                onChange={(e: any) => {
                  handleBusqueda(e)
                }}
                variant='outlined'
                value={busqueda.cityId}
                error={busqueda.cityId === -1}
                helperText={
                  busqueda.cityId === -1 ? 'Debe seleccionar una provincia' : ''
                }
              >
                <MenuItem
                  key={-1}
                  value={-1}
                >{`Seleccione Provincia`}</MenuItem>
                {city &&
                  city
                    .filter((item) => item.stateId === busqueda.stateId)
                    .map((opt: CityProvince) => (
                      <MenuItem key={opt.cityId} value={opt.cityId}>
                        {opt.name}
                      </MenuItem>
                    ))}
              </TextField>
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                select
                fullWidth
                id='neighborhoodId'
                name='neighborhoodId'
                label='Comuna'
                onChange={(e: any) => {
                  handleBusqueda(e)
                }}
                variant='outlined'
                value={busqueda.neighborhoodId}
                error={busqueda.neighborhoodId === -1}
                helperText={
                  busqueda.neighborhoodId === -1
                    ? 'Debe seleccionar una comuna'
                    : ''
                }
              >
                <MenuItem key={-1} value={-1}>{`Seleccione Comuna`}</MenuItem>
                {neighborhood &&
                  neighborhood
                    .filter(
                      (item: NeighborhoodComuna) =>
                        item.cityId === busqueda.cityId
                    )
                    .map((opt: NeighborhoodComuna) => (
                      <MenuItem
                        key={opt.neighborhoodId}
                        value={opt.neighborhoodId}
                      >
                        {opt.name}
                      </MenuItem>
                    ))}
              </TextField>
            </Grid>
          </Grid>
        )}
        <Grid container item xs={12} spacing={3}>
          <Grid item xs={12} sm={4}>
            <TextField
              type='date'
              fullWidth
              label={'Fecha Entrega Courier'}
              onChange={(e: any) => {
                handleBusqueda(e)
              }}
              id='courierDeliveryDate'
              name='courierDeliveryDate'
              variant='outlined'
              value={busqueda.courierDeliveryDate?.toString().split('T')[0]}
              error={busqueda.courierDeliveryDate.length === 0}
              helperText={
                busqueda.courierDeliveryDate.length === 0
                  ? 'Debe ingresar fecha entrega courier'
                  : ''
              }
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              select
              fullWidth
              label={'Courier'}
              onChange={(e: any) => {
                handleBusqueda(e)
              }}
              id='courierId'
              name='courierId'
              value={busqueda.courierId}
              variant='outlined'
              error={busqueda.courierId === -1}
              helperText={
                busqueda.courierId === -1 ? 'Debe seleccionar un courier' : ''
              }
            >
              <MenuItem key={-1} value={-1}>{`Seleccione Courier`}</MenuItem>
              {couriers &&
                couriers.map((opt: Courier) => (
                  <MenuItem key={opt.courierId} value={opt.courierId}>
                    {opt.name}
                  </MenuItem>
                ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              select
              fullWidth
              label={'Servicio'}
              onChange={(e: any) => {
                handleBusqueda(e)
              }}
              id='courierServiceId'
              name='courierServiceId'
              variant='outlined'
              value={busqueda.courierServiceId}
              error={busqueda.courierServiceId === -1}
              helperText={
                busqueda.courierServiceId === -1
                  ? 'Debe seleccionar un servicio'
                  : ''
              }
            >
              <MenuItem key={-1} value={-1}>{`Seleccione Servicio`}</MenuItem>
              {courierServices().map((el) => (
                <MenuItem key={el.value} value={el.value}>
                  {el.name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} sm={6}>
            <OrderOriginsDDL
              onChange={(e: any) => {
                handleBusqueda(e)
              }}
              value={busqueda.orderOriginId || 0}
              type='outlined'
              defaultLabel='Seleccione un origen de pedido...'
              isSearching={false}
              fullWidth
              error={busqueda.orderOriginId === 0}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={isRTV}
                  value={isRTV}
                  onChange={() => setIsRTV((prevState) => !prevState)}
                  name='chkRtv'
                  color='primary'
                />
              }
              label='Para Staging de Salida (RTV)'
            />
          </Grid>
        </Grid>

        <Grid container item xs={12} spacing={3}>
          <Grid item xs={12} sm={12}>
            <TextField
              fullWidth
              name='comments'
              id='comments'
              label='Observaciones'
              multiline
              rows={3}
              variant='outlined'
              InputLabelProps={{ shrink: true }}
              onChange={(e: any) => {
                handleBusqueda(e)
              }}
              value={busqueda.comments}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            style={{ padding: '0px', marginBottom: '25px' }}
          >
            <ListItemText
              primary={''}
              secondary={
                <Box>
                  <Typography component='ol' style={{ listStyle: 'square' }}>
                    <Typography variant='subtitle1' component='li' gutterBottom>
                      Puede descargar una <b>plantilla</b> desde el link que se
                      encuentra disponible a continuación.
                      <br />
                      {disabledLink ? (
                        <Fragment>
                          <Link
                            style={{
                              cursor: 'pointer',
                              pointerEvents: 'none'
                            }}
                            onClick={handleDownloadTemplate}
                          >
                            Descargando Plantilla...
                          </Link>{' '}
                          <CircularProgress size='0.9rem' />
                        </Fragment>
                      ) : (
                        <Link
                          style={{ cursor: 'pointer' }}
                          onClick={handleDownloadTemplate}
                        >
                          Descargar Plantilla
                        </Link>
                      )}
                    </Typography>
                  </Typography>
                </Box>
              }
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid
        item
        xs={12}
        justifyContent='center'
        alignItems='center'
        alignContent='center'
        style={{ textAlign: 'center' }}
      ></Grid>

      <Box className='mb25' display='flex' alignItems='center'>
        <Grid
          container
          spacing={4}
          direction='row'
          alignItems='center'
          justifyContent='center'
          style={{ justifyContent: 'center' }}
        >
          <Grid item xs={3} style={{ textAlign: 'right' }}>
            <label htmlFor='btn-upload'>
              <input
                id='btn-upload'
                name='btn-upload'
                style={{ display: 'none' }}
                type='file'
                onChange={handleSelectFile}
                accept='.xls,.xlsx'
              />
              <Tooltip
                title='Seleccionar el archivo Excel a cargar'
                placement='top-end'
              >
                <Button
                  className='btn-choose'
                  variant='outlined'
                  component='span'
                >
                  Seleccionar Archivo
                </Button>
              </Tooltip>
            </label>
          </Grid>

          <Grid item xs={5}>
            <div className='file-name'>
              {selectedFiles && selectedFiles.length > 0
                ? selectedFiles[0].name
                : null}
            </div>
          </Grid>

          <Grid item xs={1}>
            <Tooltip
              title='Enviar el archivo seleccionado al servidor para su procesamientoo'
              placement='top-end'
            >
              <Button
                className='btn-upload'
                color='primary'
                variant='contained'
                component='span'
                disabled={
                  !selectedFiles ||
                  isUploading ||
                  busqueda.stateId === -1 ||
                  busqueda.cityId === -1 ||
                  busqueda.neighborhoodId === -1 ||
                  busqueda.courierId === -1 ||
                  busqueda.courierServiceId === -1 ||
                  busqueda.orderOriginId <= 0
                }
                onClick={handleUpload}
              >
                Cargar
              </Button>
            </Tooltip>
          </Grid>

          <Grid
            item
            xs={1}
            alignContent='center'
            style={{ textIndent: '15px' }}
          >
            <Tooltip
              title='Oprima el botón SELECCIONAR para abrir el archivo a cargar y luego el botón CARGAR para enviar el archivo al servidor para su procesamiento'
              placement='top-end'
            >
              <IconButton>
                <HelpIcon />
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>
      </Box>

      <div
        style={{
          margin: '10px',
          visibility: currentFile ? 'visible' : 'hidden'
        }}
      >
        <BorderLinearProgress variant='determinate' value={progress} />

        <Box minWidth={35}>
          <Typography
            variant='body1'
            color='textSecondary'
            style={{ textAlign: 'end' }}
          >{`${progress}%`}</Typography>
        </Box>
      </div>

      <SnackBar
        open={snackBarStatus.isOpen}
        setOpen={handleSnackbar}
        message={snackBarStatus.message}
        status={snackBarStatus.status}
      ></SnackBar>
    </Fragment>
  )
}
